/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './PerpetualKyb.module.scss';

import type { PerpetualKybProps } from './PerpetualKyb.types';

export const PerpetualKyb = ({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaHref,
  rows,
  className,
}: PerpetualKybProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const revealed = useIntersection(containerRef, { threshold: 0.15 });

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!revealed) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % rows.length);
    }, 2600);

    return () => clearInterval(interval);
  }, [revealed]);

  return (
    <section className={cn(styles.section, className)}>
      <div className={cn(styles.inner, revealed && styles.innerOn)} ref={containerRef}>
        <div className={styles.glow} aria-hidden="true" />

        <div className={styles.copy}>
          <TitleBlock theme="dark" align="left" extra={eyebrow} title={title} description={description} />

          <Button type="blue" size="lg" href={ctaHref} suffixIcon="arrow-14" className={styles.cta}>
            {ctaLabel}
          </Button>
        </div>

        <div className={styles.feed} aria-hidden="true">
          <div className={styles.feedHead}>
            <span className={styles.feedTitle}>Change feed · Sample</span>
            <span className={styles.feedLive}>
              <span className={styles.feedLiveDot} />
              Live
            </span>
          </div>

          <ul className={styles.feedRows}>
            {rows.map((row, index) => (
              <li
                key={row.company + row.change}
                className={cn(
                  styles.feedRow,
                  styles[`sev-${row.severity}`],
                  index === activeIndex && styles.feedRowActive,
                )}
                style={{ '--i': index } as React.CSSProperties}
              >
                <span className={styles.feedDot} />
                <div className={styles.feedBody}>
                  <div className={styles.feedName}>{row.company}</div>
                  <div className={styles.feedChange}>{row.change}</div>
                </div>
                <span className={styles.feedTime}>{row.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
